require('./static/404.html.static')
require('./static/browserconfig.xml')
require('./static/crossdomain.xml')
require('./static/favicon.ico')
require('./static/humans.txt')
require('./static/robots.txt')
require('./icon/mstile-70x70.png')
require('./icon/mstile-150x150.png')
require('./icon/mstile-310x310.png')
require('./icon/mstile-310x150.png')



// WEBPACK FOOTER //
// ./src/static.js